import React from "react"
import { i18n } from "~Shared/locales/i18n"
import { NotificationService } from "~Shared/services"
import { NotificationDurationSec, NotificationTypeEnum } from "~Shared/services/notification.service"

export const openWindowInNewTab = ({
    url,
    notificationUrlLinkDisplayText,
    target,
    features,
}: {
    url: string
    notificationUrlLinkDisplayText?: string
    target?: "_blank" | "_self"
    features?: string
}) => {
    const targetToUse = target || "_blank"

    if (notificationUrlLinkDisplayText) {
        NotificationService.send(
            NotificationTypeEnum.INFO,
            i18n.t("notification:window.popup_opening.title"),
            <>
                {i18n.t("notification:window.popup_opening.message")}
                <a href={url} target={targetToUse} rel="noopener noreferrer">
                    {` ${notificationUrlLinkDisplayText}`}
                </a>
            </>,
            NotificationDurationSec.LONG,
            "openWindowInNewTab-notification",
        )
    }

    const newWindow = window.open(url, targetToUse, features)

    // Check if pop-up was blocked
    // window.open() returns null when blocked
    if (!newWindow || newWindow.closed || typeof newWindow.closed === "undefined") {
        NotificationService.send(NotificationTypeEnum.WARNING, i18n.t("notification:window.popup_blocked.title"), i18n.t("notification:window.popup_blocked.message"))
        return false
    }

    return true
}
